import { render, staticRenderFns } from "./MediaLibraryPreview.vue?vue&type=template&id=4531c897&scoped=true"
import script from "./MediaLibraryPreview.vue?vue&type=script&lang=js"
export * from "./MediaLibraryPreview.vue?vue&type=script&lang=js"
import style0 from "./MediaLibraryPreview.vue?vue&type=style&index=0&id=4531c897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531c897",
  null
  
)

export default component.exports